import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import apiCall from 'components/Api/api';
import { useScreenSize } from 'provider/ScreenSizeProvider';
import HeaderPayment from 'components/common/HeaderPayment';
import FooterPayment from 'components/common/FooterPayment';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PayuPaymentFailed = () => {
    const { verifyid } = useParams();
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [paymentDetails, setPaymentDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { screenHeight } = useScreenSize();

    useEffect(() => {
        const fetchVerification = async () => {
            try {
                setLoading(true);
                setError(null);
                setPaymentStatus(null);

                const response = await apiCall({ url: `transaction-info/${verifyid}`, method: 'GET' });
                // console.log('response - 25', response.data);

                if (response?.status === 200 && response?.data) {
                    const { transaction } = response.data;

                    if (transaction?.status_label?.toLowerCase() === 'failed') {
                        setPaymentDetails(transaction);
                        setPaymentStatus('failed');
                    } else {
                        setPaymentDetails(transaction); // Still show transaction details
                        setPaymentStatus('failed');
                        setError('Payment was not successful.');
                    }
                } else {
                    setPaymentStatus('failed');
                    setError('Invalid response from server.');
                }
            } catch (err) {
                console.error('Verification error:', err);
                setPaymentStatus('failed');
                setError('Something went wrong while verifying the payment.');
            } finally {
                setLoading(false);
            }
        };

        if (verifyid) {
            fetchVerification();
        }
    }, [verifyid]);

    if (loading) {
        return (
            <>
                <HeaderPayment />
                <div className="container py-4 payment_section-inner d-flex justify-content-center align-items-center">
                    <div className="row w-100 justify-content-center">
                        <div className="col-lg-8 col-md-10">
                            <div className="card shadow-sm p-4" style={{ height: screenHeight - 450 }}>
                                <div className="text-center">
                                    <div className="spinner-border loading-spinner" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <div className="mt-3">Verifying payment...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterPayment />
            </>
        );
    }

    return (
        <>
            <HeaderPayment />
            <div className="container py-4 payment_section-inner">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">
                        <div className="card shadow-sm p-3 p-md-4">
                            <div className="text-center text-success fs-1 mb-3">
                                <FontAwesomeIcon icon={faCircleXmark} color={'#dc3545'} />
                            </div>
                            <div className="text-center payment-succuss mb-3">Payment Failed!</div>

                            {error && <div className="text-danger text-center mb-3 text-wrap">{error}</div>}

                            {paymentDetails && (
                                <div className="d-flex justify-content-center align-items-center flex-column px-0 px-md-0">

                                    <div className="park-heading mb-3 d-flex justify-content-lg-center justify-content-md-start w-100">
                                        {paymentDetails?.title?.trim() ? paymentDetails.title : ''}
                                    </div>
                                    <div className='mb-4  d-flex justify-content-center row w-100'>
                                        {[
                                            { label: "Reference ID", value: paymentDetails.reference_id },
                                            // { label: "Order ID", value: paymentDetails.order_id },
                                            { label: "Status", value: paymentDetails.status_label },
                                            {
                                                label: "Amount", value: `₹${Number(paymentDetails.amount).toFixed(2)} `

                                            },
                                            { label: "Payment Gateway", value: paymentDetails.payment_gateway },
                                        ].map((item, idx) => (
                                            <div key={idx} className="col-lg-8 col-md-12 mb-2 p-0 d-flex justify-content-between">
                                                <div className="payment-sum-heading me-auto">{item.label}:</div>
                                                <div className="payment-sum-title ms-auto ">{item.value}</div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='mb-4 d-flex justify-content-center row w-100'>
                                        {[
                                            { label: "Name", value: paymentDetails.name },
                                            { label: "Email", value: paymentDetails.email },
                                            { label: "Phone", value: paymentDetails.phone },
                                        ].map((item, idx) => (
                                            <div key={idx} className="col-lg-8 col-md-12 p-0 mb-2 d-flex justify-content-between">
                                                <div className="payment-sum-heading me-auto">{item.label}:</div>
                                                <div className="payment-sum-title ms-auto text-break">{item.value}</div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mt-4">
                                        <p className="text-center text-inof-payment">
                                            Unfortunately, your transaction could not be completed.<br />
                                            Please try again or use a different payment method.
                                        </p>
                                    </div>

                                    <div className=" d-flex justify-content-center joinshareView pt-3 mt-md-3 mt-lg-3">
                                        <Link to="/" className="btn_shareView pakage px-5  ">
                                            Continue
                                        </Link>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>
            </div>
            <FooterPayment footerHeight={130} />
        </>

    );
};

export default PayuPaymentFailed;
